import React from 'react'
import { SPACING } from 'shared/theme'
import styled, { css } from 'styled-components'

import { Colors } from '../../theme/colors'
import { header4 } from '../../theme/typography'

interface PillProps {
  children: React.ReactNode
  mt?: number
  mb?: number
  background?: string
  color?: string
  variant?: 'default' | 'small' | 'large'
  fontSize?: string
  borderRadius?: string
  className?: string
  minWidth?: number
}

export function Pill({
  children,
  mb,
  mt,
  background,
  color,
  variant,
  fontSize,
  borderRadius,
  className,
  minWidth,
}: PillProps) {
  return (
    <Wrap
      $mb={mb}
      $mt={mt}
      $background={background}
      $color={color}
      $variant={variant}
      $fontSize={fontSize}
      $borderRadius={borderRadius}
      $minWidth={minWidth}
      className={className}
    >
      {children}
    </Wrap>
  )
}

const Wrap = styled.span<{
  $mt?: number
  $mb?: number
  $background?: string
  $color?: string
  $variant?: PillProps['variant']
  $fontSize?: string
  $borderRadius?: string
  $minWidth?: number
}>`
  ${header4};
  padding: 2px 8px;
  color: white;
  background: ${Colors.midGray};
  border-radius: 3px;
  display: inline-block;
  overflow: visible;
  word-wrap: break-word;
  word-break: break-word;

  ${(p) =>
    p.$variant === 'small' &&
    css`
      font-size: 12px;
      padding: 2px 6px;
      min-height: 20px;
    `};

  ${(p) =>
    p.$variant === 'large' &&
    css`
      font-size: 16px;
      padding: 6px 12px;
      min-height: 32px;
    `};

  ${(p) =>
    p.$background &&
    css`
      background-color: ${p.$background};
    `};

  ${(p) =>
    p.$color &&
    css`
      color: ${p.$color};
    `};

  ${(p) =>
    p.$mt &&
    css`
      margin-top: ${SPACING * p.$mt}px;
    `};

  ${(p) =>
    p.$mb &&
    css`
      margin-bottom: ${SPACING * p.$mb}px;
    `};

  ${(p) =>
    p.$fontSize &&
    css`
      font-size: ${p.$fontSize};
    `};
  ${(p) =>
    p.$borderRadius &&
    css`
      border-radius: ${p.$borderRadius};
    `};
  ${(p) =>
    p.$minWidth &&
    css`
      min-width: ${p.$minWidth}px;
    `};
`
